module.exports = __webpack_public_path__ + "bc9fddb843e1b4130525c669169dc2b6.MP3";